import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const FocusButton = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-align: inherit;
`;

export const LinkedLabel = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.brand.primary};
  text-decoration: underline;
  text-underline-offset: 2px;
`;
